import moment from 'moment';
import { request } from '../../requests';
export default {
  namespaced: true,
  state: {
    tasks: {
      items: [],
      loading: false,
      timestamp: null
    },
    errors: {}
  },
  actions: {
    fetchTasks({
      commit
    }, {
      projectID
    }) {
      const url = `/tables/projects/${projectID}/tasks`;
      const method = 'GET';
      commit('setTasksLoading', true);
      return request({
        url,
        method
      }).done(responseData => {
        commit('setTasksItems', responseData.result);
        commit('setTasksTimestamp', moment());
      }).always(() => {
        commit('setTasksLoading', false);
      });
    },
    taskStatus({
      commit
    }, {
      taskID,
      status
    }) {
      const url = `/forms/tasks/${taskID}/update`;
      const data = {
        status
      };
      commit('setTasksLoading', true);
      return request({
        url,
        data
      }).always(() => {
        commit('setTasksLoading', false);
      });
    }
  },
  getters: {
    prePicture(state) {
      return state.tasks.items.filter(task => task.category === 'Pre Picture Day');
    },
    postPicture(state) {
      return state.tasks.items.filter(task => task.category === 'Post Picture Day');
    },
    preRetake(state) {
      return state.tasks.items.filter(task => task.category === 'Pre Make Up Day');
    },
    postRetake(state) {
      return state.tasks.items.filter(task => task.category === 'Post Make Up Day');
    },
    errors(state) {
      return state.errors;
    },
    tasksTimestamp(state) {
      return state.tasks.timestamp;
    },
    tasksCalendar(state) {
      return state.tasks.items.map(event => {
        return {
          extendedProps: {
            description: event.description
          },
          title: event.name,
          start: event.due_date,
          end: event.due_date
        };
      });
    },
    tasksCount(state) {
      return state.tasks.items.length;
    },
    tasksDone(state) {
      return state.tasks.items.filter(task => task.status.toLowerCase() === 'completed').length;
    }
  },
  mutations: {
    setTasksItems(state, items) {
      return state.tasks.items = items;
    },
    setTasksLoading(state, loading) {
      return state.tasks.loading = loading;
    },
    setTasksTimestamp(state, timestamp) {
      return state.tasks.timestamp = timestamp;
    },
    errors(state, obj) {
      return state.errors = obj;
    }
  }
};